export default __webpack_public_path__ + "8be0be4be6b45cb306c95c63812b5690.png";